import { OTPContainer } from "pages/Edit/components/Form.styled";
import OTPField from "pages/Edit/components/OTPField";
import React, { useEffect, useState, useContext } from "react";
import { CitizenEditContext } from "../CitizenEditContext";

const VerificationOTP = () => {
  const { sendOTPMobile, setOTP } = useContext(CitizenEditContext);
  const [isPressed, setIsPressed] = useState(false);
  const [timer, setTimer] = useState(0);

  const resendOTP = async () => {
    setIsPressed(true);
    setTimer(60);
    await sendOTPMobile();
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (timer > 0) {
        setTimer(timer - 1);
      }

      if (timer === 0) {
        clearInterval(interval);
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [timer]);

  const handleOTPComplete = otp => {
    // Perform any actions with the OTP value in the parent component
    setOTP(otp);
  };

  return (
    <OTPContainer>
      <p>Ilagay ang 6-digit na OTP code na ipinadala sa iyo sa SMS upang makumpleto ang iyong request.</p>
      <div>
        <OTPField onComplete={handleOTPComplete} />
      </div>
      <p>
        Hindi pa ba natatanggap ang confirmation code? <br />
        <span
          onClick={() => resendOTP()}
          style={
            timer > 0
              ? { fontWeight: "bold", color: "#ECECEC", pointerEvents: "none" }
              : { fontWeight: "bold", color: "#2D378C", cursor: "pointer" }
          }>
          Ipadala muli
          <span>{isPressed && timer !== 0 && `(${timer})`}</span>
        </span>
      </p>
    </OTPContainer>
  );
};

export default VerificationOTP;
